import React, { Component } from "react";
import { connect } from "react-redux";
import { Singleton } from "../../js/Singleton";
import { queueMessages, agentInbound, agentOutbound, agentBoth, clockHeader, logoHeader, logoHeaderTxt } from "../../Images/Images";
import { llamadasHeader, mensajesHeader, facebookHeader, linkedinHeader, mailHeader, twitterHeader } from "../../Images/HeaderSVG";
import { SingletonSharedData } from "../../js/singletonSharedData";
import { QUEUE_COUNT, TIME_ALWAYS_VISIBLE, INTEGRATION } from "../../constants.js";
import { secondsToFormat } from "../../js/helpers/Utils/formats";
import SettingsBar from "./SettingsBar";
import { getCookie } from "../../js/cookies";
import { Logger } from "../../js/helpers/Logger.js";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import StopWatch from "./StopWatch/StopWatch";
import { setShowPswResetAlert } from "../../redux/reducers/reducer_psw_reset";
class Header extends Component {
  constructor(props) {
    super(props);
    this.sharedData = new SingletonSharedData();
    var arrayNotifications = {};
    if (this.sharedData.getGeneralPermissions()[192] === "1") {
      arrayNotifications[QUEUE_COUNT.CALLS] = {
        img: llamadasHeader,
        number: 0,
        timeInQueue: 0,
        showHours: false,
        animationType: "textNotificacion",
      };
    }
    if (this.sharedData.hasUnifiedMessage) {
      arrayNotifications[QUEUE_COUNT.MESSAGES] = {
        img: mensajesHeader,
        number: 0,
        timeInQueue: 0,
        showHours: false,
        animationType: "textNotificacion",
      };
      arrayNotifications[QUEUE_COUNT.FACEBOOK] = {
        img: facebookHeader,
        number: 0,
        timeInQueue: 0,
        showHours: false,
        animationType: "textNotificacion",
      };
      arrayNotifications[QUEUE_COUNT.LINKEDIN] = {
        img: linkedinHeader,
        number: 0,
        timeInQueue: 0,
        showHours: false,
        animationType: "textNotificacion",
      };
      arrayNotifications[QUEUE_COUNT.TWITTER] = {
        img: twitterHeader,
        number: 0,
        timeInQueue: 0,
        showHours: true,
        animationType: "textNotificacion",
      };
      arrayNotifications[QUEUE_COUNT.MAIL] = {
        img: mailHeader,
        number: 0,
        timeInQueue: 0,
        showHours: true,
        animationType: "textNotificacion",
      };
    }
    this.iconAgentArray = { 1: agentOutbound, 2: agentInbound, 3: agentBoth };

    let cookie = getCookie(TIME_ALWAYS_VISIBLE);
    Logger.Trace("COOKIE ==>> " + cookie);
    const tempTime = this.sharedData.getParameters().Sessiontime;
    
    this.state = {
      timeCounter: "00:00:00",
      callType: 1,
      notifications: arrayNotifications,
      userName: this.sharedData.getUserData().Login,
      macAddres: this.sharedData.getParameters().ClientComp,
      totalClass: "textNotificacion",
      settingsBarShowed: false,
      timeHidden: cookie === "" ? true : parseInt(cookie, 10),
      hideSettings: false, 
      hours:Math.floor(tempTime / 3600),
      minutes: Math.floor((tempTime % 3600) / 60),
      seconds: tempTime % 60,
      showConfigPsw:false
    };
    this.language = new Singleton();
    this.totalNotifications = 0;
    this.secs = 0;
    this.intervalCallQueue = null;
    this.st=null;
    this.stHideSettings=null;
  }
  componentDidMount() {
    if (this.props.whiteLabelEnabled && this.props.customLogoFormat === "svg") {
      const container = document.getElementById("custom-logo-header");
      container.innerHTML = this.props.customLogo;
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.callType === 1 || this.props.callType === 2 || this.props.callType === 3) {
      this.setState({
        callType: nextProps.callType,
      });
    }
    if (this.props.queueCount !== nextProps.queueCount || this.props.timeInQueue !== nextProps.timeInQueue) {
      if (nextProps.idChangeCount !== -1) {
        //TRAE NUEVO AVISO DE MENSAJES
        var arrayNotifications = this.state.notifications;
        if (arrayNotifications[nextProps.idChangeCount]) {
          if (
            arrayNotifications[nextProps.idChangeCount].number === 0 &&
            nextProps.queueCount !== 0
          ) {
            arrayNotifications[nextProps.idChangeCount].animationType =
              "textNotificacion appearNotification";
          }
          if (
            arrayNotifications[nextProps.idChangeCount].number > 0 &&
            nextProps.queueCount === 0
          ) {
            arrayNotifications[nextProps.idChangeCount].animationType =
              "textNotificacion hiddeNotification";
          }
          if (
            arrayNotifications[nextProps.idChangeCount].number !== 0 &&
            nextProps.queueCount !== 0
          ) {
            arrayNotifications[nextProps.idChangeCount].animationType =
              "textNotificacion newNotification";
          }
          arrayNotifications[nextProps.idChangeCount].number =
            nextProps.queueCount;
          arrayNotifications[nextProps.idChangeCount].timeInQueue =
            nextProps.timeInQueue;
          this.manageTimerCallQueue(
            nextProps.idChangeCount,
            nextProps.timeInQueue
          );
          this.setState({
            notifications: arrayNotifications,
            totalClass: "textNotificacion newNotification",
          });
        }
      }
    }
    if (nextProps.messagesIntegrations !== this.props.messagesIntegrations) {
      if (
        nextProps.messagesIntegrations.dataMessageIntegration &&
        nextProps.messagesIntegrations.dataMessageIntegration.action ===
        INTEGRATION.SETTINGS
      ) {
        this.messagesIntegrations =
          nextProps.messagesIntegrations.dataMessageIntegration;
        this.changeStateBarShow();
      }
    }
  }
  manageTimerCallQueue(idQueue, timeInQueue) {
    var arrayNotifications = this.state.notifications;
    if (this.intervalCallQueue !== null && arrayNotifications[idQueue].number<=0) {
      clearInterval(this.intervalCallQueue);
      this.intervalCallQueue=null;
    }
    if (arrayNotifications[idQueue].number > 0 && this.intervalCallQueue==null) {
      this.intervalCallQueue = setInterval(
        () => secondsToFormat(++arrayNotifications[idQueue].timeInQueue, true),
        1000
      );
    }
  }
  componentDidUpdate() { 
    if (this.props.idChangeCount !== -1 && this.state.totalClass !== "textNotificacion") {
      let indexNotification = this.props.idChangeCount;
      clearTimeout(this.st);
      this.st=setTimeout(function() {
        var arrayNotifications = this.state.notifications;
        if (arrayNotifications[indexNotification] && arrayNotifications[indexNotification].animationType !== "textNotificacion") {
          arrayNotifications[indexNotification].animationType = "textNotificacion";
          this.setState({ totalClass: "textNotificacion", notifications: arrayNotifications });
        }
      }.bind(this), 500);
    }
    this.openResetPsw();
  }
  openResetPsw(){
    if(this.props.openConfig && !this.state.settingsBarShowed && !this.state.hideSettings)
    {
        this.showHideSettingsBar();
        this.setState({showConfigPsw:true});
    }
  }
  componentWillUnmount() {
    if (this.intervalCallQueue !== null) {
      clearInterval(this.intervalCallQueue);
    }
    clearTimeout(this.st);
    clearTimeout(this.stHideSettings);
  }
  renderNotifications(typeNotification) {
    var notificationsRender = [];
    this.totalNotifications = 0;
    for (let i in this.state.notifications) {
      let item = this.state.notifications[i];
      this.totalNotifications += item.number;
      notificationsRender.push(
        <OverlayTrigger
          key={`tlt-notificationContainer-queue-${i}`}
          placement="bottom"
          overlay={
            <Tooltip className="notificationContainer-tooltip bottom show" key={`notificationContainer-tooltip-header-${i}`} id={`notificationContainer-tooltip-headerId-${i}`} >
              {this.language.getText("GUIHeaderCallQueue")}
            </Tooltip>
          }
        >
          <div className={"notificationContainer " + typeNotification + " " + (this.state.timeHidden && " hiddenTime")} key={"item" + i} >
            <p className={item.animationType}>{item.number}</p>
            <div className={"imageNotification" + (item.number > 0 ? " imageActive " : " imageInactive ")}>
              {item.img}
            </div>
            <p className={"timeInQueue " + typeNotification + (this.state.timeHidden && " hiddenTime")} >
              {secondsToFormat(item.timeInQueue, item.showHours)}
            </p>
          </div>
        </OverlayTrigger>
      );
    }
    return notificationsRender;
  }
  changeStateBarShow() {
    this.setState({ settingsBarShowed: !this.state.settingsBarShowed });
  }
  showHideSettingsBar = () => {
    this.props.setShowPswResetAlert(false);
    if (this.state.settingsBarShowed) {
      this.setState({ hideSettings: true,showConfigPsw:false });
      clearTimeout(this.stHideSettings);
      this.stHideSettings=setTimeout(() => {
        this.setState({ settingsBarShowed: !this.state.settingsBarShowed });
      }, 500);
    } else {
      this.setState({ settingsBarShowed: !this.state.settingsBarShowed });
      this.setState({ hideSettings: false });
    }
  }

  onChangeSesionTime = (timeCounter) => {
    this.setState({ timeCounter });
  }

  render() {
    return (
      <div className={`header ${(this.state.settingsBarShowed) ? "menuAgent" : ""}`}      >
        <div className="headerUserBox" onClick={this.showHideSettingsBar}        >
          <img alt={"icon"} className="imageHeader" src={this.iconAgentArray[this.state.callType]} />
          <div className="infoUserContainer">
            <OverlayTrigger
              key="tlt-userName1"
              placement="bottom"
              overlay={
                <Tooltip className="notificationContainer-tooltip bottom show name" id="tooltipId-tlt-userName1">{this.state.userName}</Tooltip>
              }
            >
              <p className="nameUser">{this.state.userName}</p>
          </OverlayTrigger>
            <br />
            <p className="sessionTime">
              <StopWatch onChange={this.onChangeSesionTime} hours={this.state.hours} minutes={this.state.minutes} secondsInitial={this.state.seconds} isAscending />
            </p>
            <img alt={"icon"} className="imageClock" src={clockHeader}></img>
          </div>
        </div>
        <div className="notificationContainer normal generalCounter">
          {this.sharedData.hasUnifiedMessage && (
            <div>
              <p className={this.state.totalClass}>{this.totalNotifications}</p>
              <img alt={"icon"} className="imageNotification" src={queueMessages} />
            </div>
          )}
          <div className="smallNotificationHeader">
            {this.renderNotifications("small")}
          </div>
        </div>
        <div
          className={
            "notificationHeader " +
            (this.sharedData.hasUnifiedMessage ? "hiddenHeaderIcons" : "")
          }
        >
          {this.renderNotifications("normal")}
        </div>
        <div className="imagenLogo">
          {this.props.whiteLabelEnabled ? (
            <div id="custom-logo-header">
              {this.props.customLogoFormat === "image" && (
                <img
                  id="custom-header-img"
                  alt=""
                  src={this.props.customLogo}
                />
              )}
            </div>
          ) : (
              <React.Fragment>
                <img alt="icon" className="logoIcon" src={logoHeader}></img>
                <img alt="icon" className="logoText" src={logoHeaderTxt}></img>
              </React.Fragment>
            )}
        </div>
        {(this.state.settingsBarShowed)&& (
          <SettingsBar
            callType={this.state.callType}
            userName={this.state.userName}
            macAddres={this.state.macAddres}
            timeSession={this.state.timeCounter}
            onChangeVisibility={(visible) => this.setState({ timeHidden: visible })}
            onClick={this.showHideSettingsBar}
            messagesIntegrations={this.messagesIntegrations}
            hideSettings={this.state.hideSettings}
            showConfigPsw={this.state.showConfigPsw}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    messagesIntegrations: state.messagesIntegrations,
    whiteLabelEnabled: state.whiteLabelState.whiteLabelEnabled,
    customLogo: state.whiteLabelState.header,
    customLogoFormat: state.whiteLabelState.imageFormat,
    queueCount: state.queueCount.count,
    timeInQueue: state.queueCount.time,
    idChangeCount: state.queueCount.countType,
    openConfig: state.setFlagShowAlert.showAlert
  };
}

function mapDispatchToProps(dispatch) {
  return ({
    setShowPswResetAlert: flag => { dispatch(setShowPswResetAlert(flag)); },
  })
}
export default Header = connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx